var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUniversity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43.19 31.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #cccccb;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "University"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chapeau"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.34,15.36v8.99c0,6.12-12.58,6.12-12.58,6.12,0,0-12.67,0-12.77-6.12-.05-3.83-.14-8.99-.14-8.99h.12l12.46,6.3,12.67-6.3h.25Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "42.19 11.33 34.09 15.36 21.43 21.66 8.97 15.36 1 11.33 21.39 1 42.19 11.33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pendant"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 38.69,
    y1: 13.38,
    x2: 38.69,
    y2: 19.09
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 38.69,
    cy: 20.58,
    rx: 1.41,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.17,24.01v2.32h-2.96v-2.32s0-.07,0-.11c.05-.81.69-1.46,1.47-1.46s1.41.65,1.47,1.46c0,.04,0,.07,0,.11Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversity);
export default __webpack_public_path__ + "static/media/University.da695cd81d8aa68ae58968fe65d23387.svg";
export { ForwardRef as ReactComponent };